// extracted by mini-css-extract-plugin
module.exports = {"button":"button-AWZPc","button__price":"button__price-8vnfu","fare":"fare-3xvBa","option":"option-1umWw","fareConditions__closeButton":"fareConditions__closeButton-o3E-k"};